exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-payments .wrapper-main .container{margin-top:30px;margin-bottom:70px}.my-payments .wrapper-main .container .help-page-header{margin-bottom:30px;text-align:center}.my-payments .wrapper-main .container .help-page-header h1{font-size:25px;color:#545454;font-weight:600}@media screen and (max-width:768px){.my-payments .wrapper-main .container,.my-payments .wrapper-main .container .help-page-header{margin-top:15px}.my-payments .wrapper-main .container .help-page-header h1{font-size:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/dashboard/payments/help/help.scss
// module id = 751
// module chunks = 0